angular.module('Const').constant('icons', {
    map: {
        car: '/images/map_icons/CAR.png',
        van: '/images/map_icons/VAN.png',
        truck: '/images/map_icons/TRUCK.png',
        motorcycle: '/images/map_icons/MOTORCYCLE.png',
        bicycle: '/images/map_icons/BICYCLE.png',
        airplane: '/images/map_icons/PLANE.png',
        ship: '/images/map_icons/SEASHIP.png',
        depot: '/images/map_icons/DEPOT.png'
    }
});


//////////////////
// WEBPACK FOOTER
// ./js/consts/icons
// module id = 735
// module chunks = 0